import React, { useState, useEffect } from "react";
import { TextField, Button, Grid, Paper } from "@mui/material";
import { useDispatch } from "react-redux";
import { UpdateUserCustodian } from "../../../redux/Actions/userStatusService";

const CoinbaseTabContent = ({ user, userCust, custId, selectedTab, userAccountId, onAccountIdChange }) => {
  const dispatch = useDispatch();
  
  const [formData, setFormData] = useState({
    walletId: "",
    portfolioId: "",
    accountId: "",
  });

  const [errors, setErrors] = useState({
    walletId: false,
    portfolioId: false,
    accountId: false,
  });

  // Update form data whenever userCust or userAccountId changes
  useEffect(() => {
    if (Array.isArray(userCust) && userCust.length > 0) {
      const initialWalletId = userCust.find((item) => item.name === "WALLET_ID")?.value || "";
      const initialPortfolioId = userCust.find((item) => item.name === "PORTFOLIO_ID")?.value || "";
      const initialAccountId = userCust.find((item) => item.name === "ACCOUNT_ID")?.value || "";
      
      setFormData({
        walletId: initialWalletId,
        portfolioId: initialPortfolioId,
        accountId: initialAccountId,
      });
    }
  }, [userCust]);

  // Sync accountId with parent component's userAccountId for IBKR
  useEffect(() => {
    if (selectedTab === "ibkr" || selectedTab === "interactive-brokers") {
      if (userAccountId && userAccountId !== "No IBKR Account Found") {
        setFormData(prev => ({
          ...prev,
          accountId: userAccountId,
        }));
      }
    }
  }, [userAccountId, selectedTab]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Sync accountId changes back to parent component for IBKR
    if (name === "accountId" && (selectedTab === "ibkr" || selectedTab === "interactive-brokers")) {
      if (onAccountIdChange) {
        onAccountIdChange(value);
      }
    }

    setErrors({
      ...errors,
      [name]: false,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Determine which tab is active (handle both naming conventions)
    const isIBKR = selectedTab === "ibkr" || selectedTab === "interactive-brokers";
    
    const keys = isIBKR ? [
      {
        name: "ACCOUNT_ID",
        value: formData.accountId || userAccountId || "",
      },
    ] : [
      {
        name: "WALLET_ID",
        value: formData.walletId || "",
      },
      {
        name: "PORTFOLIO_ID",
        value: formData.portfolioId || "",
      },
    ];

    // Only submit if we have valid values
    if (isIBKR && !keys[0].value) {
      setErrors(prev => ({ ...prev, accountId: true }));
      return;
    }
    
    if (!isIBKR && (!keys[0].value || !keys[1].value)) {
      setErrors(prev => ({
        ...prev,
        walletId: !keys[0].value,
        portfolioId: !keys[1].value,
      }));
      return;
    }

    // Dispatch the action with the correct parameters
    dispatch(UpdateUserCustodian({ custId, keys }));
  };

  return (
    <div>
      <Paper elevation={3} style={{ padding: "16px" }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {selectedTab === "coinbase" && (
              <>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Wallet ID"
                    variant="outlined"
                    fullWidth
                    name="walletId"
                    value={formData.walletId}
                    onChange={handleChange}
                    required
                    error={errors.walletId}
                    helperText={errors.walletId && "Wallet ID is required"}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Portfolio ID"
                    variant="outlined"
                    fullWidth
                    name="portfolioId"
                    value={formData.portfolioId}
                    onChange={handleChange}
                    required
                    error={errors.portfolioId}
                    helperText={errors.portfolioId && "Portfolio ID is required"}
                  />
                </Grid>
              </>
            )}
            {(selectedTab === "ibkr" || selectedTab === "interactive-brokers") && (
              <Grid item xs={12}>
                <TextField
                  label="IBKR Account ID"
                  variant="outlined"
                  fullWidth
                  name="accountId"
                  value={formData.accountId || userAccountId || ""}
                  onChange={handleChange}
                  required
                  error={errors.accountId}
                  helperText={errors.accountId && "Account ID is required"}
                  placeholder="Enter IBKR Account ID"
                />
              </Grid>
            )}
          </Grid>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ marginTop: "16px" }}
          >
            Submit
          </Button>
        </form>
      </Paper>
    </div>
  );
};

export default CoinbaseTabContent;
